
import React from 'react';
import { InputContainer } from '../../../../../../../common/components/form/form.module';

export const CompaignRecipientInfoComponent = ({
  choosenEmailPlan,
  choosenCampaign,
  customerTags,
  handleInnerFormChange,
}: any) => {


  console.log(customerTags, "customerTags")
  return (
    <>
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
          label="Reply To"
          labelField="Reply To"
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(event.target.value, 'ReplyToEmailInclusions');
          }}
          type="text"
          value={choosenEmailPlan?.ReplyToEmailInclusions || ''}
        />


        <InputContainer
          label="Recipient"
          labelField="displayText"
          list={customerTags}
          type="multiselect"
          valueField="Id"
          value={choosenEmailPlan?.RecipientTagIdInclusions}
          onValueChange={(newValue: any) => {
            const categoryData = newValue.map((option: any) => option?.value || "");
            handleInnerFormChange(categoryData, "RecipientTagIdInclusions");
          }}
        />
        <InputContainer
          label="CC"
          labelField="displayText"
          list={customerTags}
          type="multiselect"
          valueField="Id"
          value={choosenEmailPlan?.CCTagIdInclusions}
          onValueChange={(newValue: any) => {
            const categoryData = newValue.map((option: any) => option?.value || "");
            handleInnerFormChange(categoryData, "CCTagIdInclusions");
          }}
        />
        <InputContainer
          label="BCC"
          labelField="displayText"
          list={customerTags}
          type="multiselect"
          valueField="Id"
          value={choosenEmailPlan?.BCCTagIdInclusions}
          onValueChange={(newValue: any) => {
            const categoryData = newValue.map((option: any) => option?.value || "");
            handleInnerFormChange(categoryData, "BCCTagIdInclusions");
          }}
        />
       
      </div>

    </>
  );
};
export default CompaignRecipientInfoComponent;
